__turbopack_context__.v({
  "header": "pQAu-W_header",
  "organizationsList": "pQAu-W_organizationsList",
  "paymentButton": "pQAu-W_paymentButton",
  "paymentButtonsWrapper": "pQAu-W_paymentButtonsWrapper",
  "totalTable": "pQAu-W_totalTable",
  "wrapper": "pQAu-W_wrapper",
});
